import appApi from '../../../../../api/app-api';
import { showSnackbar } from '../../../../../component/snack-bar/snack-bar';

export const manualFinishLectureOperation = async (
  branchId: number,
  programId: number,
  courseId: number,
  lectureId: number,
  sessionId: number,
  endTime: Date,
  breakMinutes: number,
): Promise<boolean> => {
  try {
    await appApi.manualFinishLecture(
      branchId,
      programId,
      courseId,
      lectureId,
      sessionId,
      endTime,
      breakMinutes,
    );

    showSnackbar('ההרצאה נסגרה בהצלחה', 'success');
    return true;
  } catch (error) {
    console.error('Error manually finishing lecture:', error);
    showSnackbar('אירעה שגיאה בסגירת ההרצאה', 'error');
    return false;
  }
};
